import { render, staticRenderFns } from "./KnowledgeCenterContent.vue?vue&type=template&id=1f85e827&scoped=true&"
import script from "./KnowledgeCenterContent.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCenterContent.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeCenterContent.vue?vue&type=style&index=0&id=1f85e827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85e827",
  null
  
)

export default component.exports